import { render, staticRenderFns } from "./ModattaSideModalOfferDetails.vue?vue&type=template&id=70fec8b3&scoped=true"
import script from "./ModattaSideModalOfferDetails.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalOfferDetails.vue?vue&type=script&lang=js"
import style0 from "./ModattaSideModalOfferDetails.vue?vue&type=style&index=0&id=70fec8b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fec8b3",
  null
  
)

export default component.exports